import React, { useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const navItems = [
  { label: "Home", href: "/" },
  { label: "About us", href: "/about" },
  { label: "Project", href: "/projects" },
  { label: "Client stories", href: "/client-stories" },
  { label: "Contact us", href: "/contact" },
];

const Navbar = () => {
  const navRef = useRef(null);

  useGSAP(() => {
    if (!navRef.current) return;

    gsap.fromTo(
      navRef.current,
      { y: -30, autoAlpha: 0 },
      {
        y: 0,
        autoAlpha: 1,
        duration: 0.9,
        ease: "power3.out",
      }
    );

    return () => {};
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50 px-0 pt-3 sm:px-0">
      <nav
        ref={navRef}
        className="flex w-full items-center justify-between gap-3 px-3 py-2.5 shadow-2xl sm:px-6 md:px-8"
      >
        <Link to="/" className="shrink-0">
          <img
            src="/img/logo.png"
            alt="B-fos logo"
            className="h-9 w-auto rounded-sm object-contain sm:h-10"
          />
        </Link>

        <ul className="flex items-center gap-1 sm:gap-1.5 md:gap-2 lg:gap-3">
          {navItems.map((item) => (
            <li key={item.href} className="shrink-0">
              <NavLink
                exact={item.href === "/"}
                to={item.href}
                activeClassName="bg-amber-400 text-slate-950 border-amber-300"
                className="inline-flex rounded-md border border-white/30 bg-slate-900/70 px-1.5 py-1 text-[10px] font-semibold leading-none text-white transition-colors duration-200 hover:border-amber-300 hover:text-amber-300 sm:px-2 sm:text-[11px] md:px-2.5 md:py-1.5 md:text-xs lg:px-3 lg:text-sm"
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
